import { InjectionToken } from '@angular/core';
import { type AdvancedSearchService } from '@modules/search/services/advanced-search.service';

/**
 * The enclosing {@link AdvancedSearchService} instance, captured by a surface that shadows the
 * service with its own scoped instance (the Knowledge Panel captures the surrounding space-context
 * instance — inside the dynamic panel, that is the DP-scoped one). Consumers that open UI OUTSIDE
 * the shadowing scope (e.g. a full-form modal) re-provide this instance so the modal's search
 * affordances never target the KP's isolated result-list search.
 */
export const HOST_ADVANCED_SEARCH_SERVICE = new InjectionToken<AdvancedSearchService>('HOST_ADVANCED_SEARCH_SERVICE');
